import { setRemoteDefinitions } from '@nx/angular/mf';
import remoteDefinitions from './module-federation';

setRemoteDefinitions(remoteDefinitions); 
import(/* webpackPrefetch: true */ './main');
